import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getInvoicesKey } from '../../utils/keys';
export const useInvoices = (options) => {
    const { useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const invoicesKey = getInvoicesKey();
    return useQuery(invoicesKey, () => client.billing.invoices(), {
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useInvoices.js.map